import React, { Component } from 'react';
import Key from '../Key';
import {testKeyFromArr} from '../Key';

var keys = [
  'А',
  'Б',
  'В',
  'Г',
  'Д',
  'Ж',
  'З',
  'К',
  'Е',
  '1',
  '2',
  '3',
  '4',
  '5',
  '6',
  '7',
  '8',
  '9',
  '0',
  '-',
  '/',
  '\\',
]

var Keyboard = React.createClass({

  handleClick: function(data){
    this.props.actionSaveField(this.props.text + data)
  },
  handleErase: function(data){
      this.props.actionSaveField(this.props.text.replace(/.$/, ''))
  },
  componentWillReceiveProps(nextProps) {
    if(JSON.stringify(nextProps.opperativeKey) !== JSON.stringify(this.props.opperativeKey)) {
      if(nextProps.opperativeKey.keyCode == '8'){
        this.handleErase();
        return;
      }
      if(typeof nextProps.opperativeKey.key != 'undefined'){
        if(testKeyFromArr(nextProps.opperativeKey.key, keys)){
          this.handleClick(nextProps.opperativeKey.key)
        }
      }
      
    }
  },
  render: function(){
    if(!this.props.mobile){
      return(
        <div className="keyboardWrapper">
          <div className="Keyboard letters">
            <div className="button emptyBorder"></div>
            <div className="button emptyBorder"></div>
            <Key actionClickButton={this.handleClick} val="А" />
            <Key actionClickButton={this.handleClick} val="Б" />
            <Key actionClickButton={this.handleClick} val="В" />
            <Key actionClickButton={this.handleClick} val="Г" />
            <Key actionClickButton={this.handleClick} val="Д" />
            <Key actionClickButton={this.handleClick} val="Ж" />
            <div className="button emptyBorder"></div>
            <div className="button emptyBorder"></div>
            <div className="button emptyBorder"></div>
            <div className="button emptyBorder"></div>
            <Key actionClickButton={this.handleClick} val="З" />
            <Key actionClickButton={this.handleClick} val="К" />
            <Key actionClickButton={this.handleClick} val="Е" />
            <Key actionClickButton={this.handleClick} val="1" />
            <Key actionClickButton={this.handleClick} val="2" />
            <Key actionClickButton={this.handleClick} val="3" />
            <div className="button emptyBorder"></div>
            <div className="button emptyBorder"></div>
            <div className="button emptyBorder"></div>
            <div className="button emptyBorder"></div>
            <Key actionClickButton={this.handleClick} val="4" />
            <Key actionClickButton={this.handleClick} val="5" />
            <Key actionClickButton={this.handleClick} val="6" />
            <Key actionClickButton={this.handleClick} val="7" />
            <Key actionClickButton={this.handleClick} val="8" />
            <Key actionClickButton={this.handleClick} val="9" />
            <div className="button emptyBorder"></div>
            <div className="button emptyBorder"></div>
            
            {this.props.handleOpenNumbers ? (
              <div className="button next" style={{width: 192}} onClick={this.props.handleOpenNumbers}>Назад</div>
            ) : (
              <div>
                <div className="button emptyBorder"></div>
                <div className="button emptyBorder"></div>
              </div>
            )}
            <Key actionClickButton={this.handleClick} val="0" />
            <Key actionClickButton={this.handleClick} val="/" />
            <Key actionClickButton={this.handleClick} val="-" />
            <Key actionClickButton={this.handleClick} val="\" />
            <div className="button next" style={{width: 192}} onClick={this.handleErase}>Стереть</div>
          </div>
        </div>
      );
    }else{
      // return(
      //   <div className="keyboardWrapper Numbers">
      //     <div className="Keyboard numbers">
      //       <div className="row">
      //         <div className="innerTable">
      //           <div className="row">
      //             <Key actionClickButton={this.handleClick} val="1" />
      //             <Key actionClickButton={this.handleClick} val="2" />
      //             <Key actionClickButton={this.handleClick} val="3" />
      //             <Key actionClickButton={this.handleClick} val="4" />
      //             <Key actionClickButton={this.handleClick} val="5" />
      //           </div>
      //           <div className="row">
      //             <Key actionClickButton={this.handleClick} val="6" />
      //             <Key actionClickButton={this.handleClick} val="7" />
      //             <Key actionClickButton={this.handleClick} val="8" />
      //             <Key actionClickButton={this.handleClick} val="9" />
      //             <Key actionClickButton={this.handleClick} val="0" />
      //           </div>
      //           <div className="row">
      //             <Key actionClickButton={this.handleClick} val="А" />
      //             <Key actionClickButton={this.handleClick} val="Б" />
      //             <Key actionClickButton={this.handleClick} val="В" />
      //             <Key actionClickButton={this.handleClick} val="Г" />
      //             <Key actionClickButton={this.handleClick} val="Д" />
      //           </div>
      //           <div className="row">
      //             <Key actionClickButton={this.handleClick} val="Е" />
      //             <Key actionClickButton={this.handleClick} val="Ж" />
      //             <Key actionClickButton={this.handleClick} val="З" />
      //             <Key actionClickButton={this.handleClick} val="К" />
      //             <Key actionClickButton={this.handleClick} val="-" />
      //           </div>
      //         </div>
      //       </div>
      //       <div className="row" style={{height: "19.6%"}}>
      //         <div className="innerTable">
      //           <Key actionClickButton={this.handleClick} className="serviceClass serviceClass2" style={{width: "19.5%"}} val="/" />
      //           <div className="serviceClass button" onClick={this.handleErase}>Стереть</div>
      //         </div>
      //       </div>
      //     </div>
      //   </div>
      // );
      return null
    }

  }
});

export default Keyboard;



/** WEBPACK FOOTER **
 ** ./assets/apps/AppForm/components/KeyboardWrapper/components/KeyboardsSwitcher/components/NumbersAndLetters/index.jsx
 **/